import styled, { css } from 'styled-components';

import dottedDivider from './dotted-divider.png';
import whiteDottedDivider from './dotted-divider-white.png';

type StyledDividerProps = {
  white?: boolean;
  black?: boolean;
  shaded: boolean;
  darkened?: boolean;
  dotted?: boolean;
  vertical?: boolean;
  size?: number;
};

export const StyledDivider = styled.span<StyledDividerProps>`
  display: block;
  flex-grow: 1;
  background: ${({ theme, white, black, shaded, darkened }) => {
    if (black) {
      return theme.colors.black;
    }

    if (white) {
      return theme.colors.white;
    }

    if (darkened) {
      return theme.colors.shadowGray3;
    }

    if (shaded) {
      return theme.colors.gray3;
    }

    return theme.colors.gray1;
  }};

  ${({ dotted, white, darkened, black }) => dotted && css`
    background: url(${(white || darkened) && !black ? whiteDottedDivider : dottedDivider});
    background-size: 7px 7px;
  `}

  ${({ vertical }) => !vertical && css<StyledDividerProps>`
    width: 100%;
    height: ${({ size }) => size}px;
    max-height: ${({ size }) => size}px;
  `}

  ${({ vertical }) => vertical && css<StyledDividerProps>`
      width: ${({ size }) => size}px;
      max-width: ${({ size }) => size}px;
      margin-left: -1px;
      margin-right: -1px;
  `}
`;
